const n = {
  "cdr-banner": "cdr-banner_13-5-3",
  "cdr-banner__wrapper--prominence": "cdr-banner__wrapper--prominence_13-5-3",
  "cdr-banner__main": "cdr-banner__main_13-5-3",
  "cdr-banner__icon-left": "cdr-banner__icon-left_13-5-3",
  "cdr-banner__message": "cdr-banner__message_13-5-3",
  "cdr-banner__message-body": "cdr-banner__message-body_13-5-3",
  "cdr-banner__icon-right": "cdr-banner__icon-right_13-5-3",
  "cdr-banner__info-action": "cdr-banner__info-action_13-5-3",
  "cdr-banner--default": "cdr-banner--default_13-5-3",
  "cdr-banner__wrapper": "cdr-banner__wrapper_13-5-3",
  "cdr-banner--info": "cdr-banner--info_13-5-3",
  "cdr-banner--warning": "cdr-banner--warning_13-5-3",
  "cdr-banner--success": "cdr-banner--success_13-5-3",
  "cdr-banner--error": "cdr-banner--error_13-5-3"
};
export {
  n as default
};
